import { Fragment } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import { Header, Contact, Blog, Footer } from '@/components/Landing'

import OurProductsComponent from '@/features/OurProducts/templates/OurProducts'

function OurProductPage() {
  return (
    <Fragment>
      <NextSeo title="สร้าง Privacy Policy แบบมือโปร" />

      <div css={{ overflow: 'hidden' }}>
        <Header isAltStyle />
        <OurProductsComponent />
        <Blog />
        <Contact />
        <Footer />
      </div>
    </Fragment>
  )
}

export default withPage()(OurProductPage)
